export class MSSelect{
    constructor(param) {
        this.parent = param.parent;
        this.select = param.select;
        this.options = param.options ?? {data:[]};
    }

    create() {
        console.warn('create is obsolete, please use $create instead');
        return this.$create()
    }

    $create() {
        var $select = $("<select/>");
        if (this.select?.class){
            $select.addClass(this.select.class);
        }
        if (this.select?.id){
            $select.attr({"id":this.select.id});
        }
        if (this.select?.name){
            $select.attr({"id":this.select.name});
        }
        if (this.parent){
            $select.appendTo(this.parent);
        }
        if(this.select?.multiple){
            $select.attr({"multiple":"multiple"});
        }
        if(this.select?.disabled){
            $select.attr({"disabled":"disabled"});
        }
        this.options.data.forEach(opt => {
            var $option=$("<option/>").attr({"value":opt.value}).text(opt.text).appendTo($select);
            if(opt.value == this.options.selected){
                $option.attr({"selected":"selected"})
            }
        });

        //$select.changed((e) => this.m_form.on_changed(e));

        return $select;
    }

    onCreated(iFieldConfig) {
        this.$m_input = this.$m_element.find('select');
        super.onCreated(iFieldConfig);
    }

}